<ng-template #nextRefreshHeaderTemplate>
  <div class="d-flex align-items-center">
    <div>Next Refresh Date</div>
    <app-icon tooltip="Next Refresh Date depends on data availability from business." icon="INFO"></app-icon>
  </div>
</ng-template>

<div class="layout-wrapper">
  <div class="menubar">
    <div class="menubar-start d-flex align-items-center">
      <!-- @if(hasAccess){  -->
      <!-- @if(currentPath !== '/3d-viewer') { -->
      <div class="mx-2 d-flex">
        <app-icon (click)="onShowSideBar()" icon="MENU" [color]="'var(--bg-light)'"></app-icon>
      </div>
      <!-- }  -->
      <!-- } -->

      <div class="wr-logo flex" [ngClass]="{ 'cursor-pointer': currentPath !== '/3d-viewer' }" [ngStyle]="{
          marginLeft: currentPath !== '/3d-viewer' ? '0' : '1rem'
        }">
        <img height="30rem" width="100rem" src="assets/icons/aa_logo.png" alt="loading" (click)="onLogoClick()" />
        <div class="divider"></div>
        <span class="project-name" (click)="goHome()">{{ projectName }}</span>
      </div>
    </div>
    <div class="menubar-end">
      @if(!superAdminUrls.includes(currentPath)){
      <div class="pe-2">
        <div class="dropdown me-2" *ngIf="currentRole?.value">
          <div class="role-badge" id="roleDropdownButton" role="button" data-bs-toggle="dropdown" aria-expanded="false"
            style="cursor: pointer">
            {{ currentRole.value }}
            <span *ngIf="availableRoles.length > 1">&nbsp;⇄</span>
          </div>
          @if(availableRoles.length > 1){
          <ul class="dropdown-menu" aria-labelledby="roleDropdownButton">
            @for (role of availableRoles; track role.id) {
            <li>
              <a class="dropdown-item" (click)="onRoleSelect(role)">
                {{ role.value }}
              </a>
            </li>
            }
          </ul>
          }
        </div>
      </div>

      }
      <div *ngIf="showLastRefreshDate">
        <div class="refresh-date" style="color: var(--bg-light); cursor: pointer" (click)="onClickRefreshDate()">
          <div class="flex-column align-items-center text-center">
            <div class="small-hidden">Last Refresh Date</div>
          </div>
          <app-icon [tooltip]="lastRefreshedDate" [icon]="'INFO'" [color]="'var(--bg-light)'"></app-icon>
        </div>
      </div>

      <div class="d-flex align-items-center pe-3">
        <app-icon [ngbPopover]="userGuide" placement="bottom-end" [color]="'var(--bg-light)'"
          [icon]="'HELP'"></app-icon>

        <app-notifications></app-notifications>

        <div class="avatar" style="height: 1.5rem; width: 1.5rem; margin: 0.5rem; cursor: pointer"
          [ngbPopover]="profileMenu" triggers="click" [autoClose]="'outside'" placement="bottom-end"
          (click)="toggleProfile()">
          <!-- <span style="font-size: 0.7rem">{{ initials }}</span> -->
          <img *ngIf="userPhoto; else initialsTpl" [src]="userPhoto" alt="Profile"
            style="width:100%; height:100%; border-radius:50%; object-fit:cover;" />
        </div>
      </div>
    </div>
  </div>

  <ng-template #initialsTpl>
    <span style="font-size: 0.7rem; display:flex; align-items:center; justify-content:center; width:100%; height:100%;">
      {{ initials }}
    </span>
  </ng-template>

  <div class="flex">
    <app-sidebar (onHide)="onHideSideBar()"></app-sidebar>
  </div>

  <app-alert></app-alert>
  <div style="position: relative" id="layout-container" class="layout-body">
    <div class="px-3 layout-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<app-sidebar [visible]="visible" (onHide)="onHideSideBar()"></app-sidebar>
@if(isDialogVisible){
<app-table [title]="'Last Refresh Date'" [inTableDialog]="true" [isTableDialogVisible]="isDialogVisible"
  (onClosePopup)="onClosePopup()" [cols]="lastRefreshedDatasets.columns"
  [defaultColumns]="lastRefreshedDatasets.columns" [data]="lastRefreshedDatasets.data"></app-table>
}

<ng-template #userGuide>
  <div style="width: 10rem">
    <ul class="list-group">
      <li class="list-group-item cursor-pointer">
        <div class="d-flex align-items-center" (click)="onFaqClick()">
          <app-icon [icon]="'INFO'" color="var(--text-primary)" [iconSize]="'18px'"></app-icon>
          <span>FAQs</span>
        </div>
      </li>
      <li class="list-group-item cursor-pointer">
        <div class="d-flex align-items-center">
          <app-icon [icon]="'CONTACT_SUPPORT'" color="var(--text-primary)"></app-icon>
          <span>Help</span>
        </div>
      </li>
    </ul>
  </div>
</ng-template>
<ng-template #profileMenu>
  <!-- <div class="profile-card"> -->
  <div class="profile-header">
    @if(userPhoto){
    <img class="avatar" [src]="userPhoto" alt="Profile" style="object-fit:cover;" />
    }
    @else{
    <div class="avatar">{{ initials }}</div>
    }
    <div class="user-info">
      <div class="user-name">{{ userName }}</div>
      <div class="user-email">{{ userEmail }}</div>
    </div>
  </div>

  <div class="sign-out">
    <a href="" (click)="onSignOut()">Sign out</a>
  </div>
  <!-- </div> -->
</ng-template>

@if(faqVisible){
<app-drawer [title]="'FAQs'" [visible]="faqVisible" (onClose)="onFaqClose()">
  <div [ngStyle]="{ width: '98%', marginBottom: '1rem', marginTop: '0.5rem' }">
    <input id="serachFaq" class="custom-input" placeholder="Search..." [value]="searchText"
      (input)="onSearch($event)" />
  </div>
  @for(el of faqData; track $index){
  <app-accordion [id]="$index" [title]="highlightSearch(el.question, searchText)" [ngStyle]="{ width: '98%' }">
    <span [innerHTML]="highlightSearch(el.answer, searchText)"></span>
  </app-accordion>
  }
</app-drawer>
}